<template>
  <parent>
    <div class="behaviors-form-wrapper h-100">
      <form-wrapper v-if="!loading && loaded && !showCacheForm && !showRequestForm">

        <template v-slot:body>
          <validation-observer
            ref="behaviorRules"
            tag="form"
          >
            <paper-simple class="pb-1">
              <validation-provider
                #default="{ errors }"
                name="Path Pattern"
                rules="required"
              >
                <input-field
                  label="Path Pattern"
                  label-position="top"
                  :info="messages.pathPattern2"
                  :error="errors.length ? errors[0] : null"
                  @openInfo="showInfo(messages.pathPattern2.title, messages.pathPattern2.message)"
                >
                  <b-form-input
                    v-model="behaviors.pathPattern"
                    :state="errors.length > 0 ? false:null"
                    placeholder="eg. /images/*"
                    :disabled="behaviors.pathPattern === '*' && details"
                  />
                </input-field>
              </validation-provider>
              <input-field
                :info="messages.originOrOriginGroup"
                class="onfp-checkbox mb-2"
                @openInfo="showInfo(messages.onfp.title, messages.onfp.message)"
              >
                <b-form-checkbox
                  v-model="behaviors.onTheFlyPackaging"
                  name="check-button"
                  switch
                  inline
                >
                  Use ONFP
                </b-form-checkbox>
              </input-field>
              <input-field
                v-if="elementary && originOptions.length > 0"
                label="Origin or Origin Group"
                label-position="top"
                :info="messages.originOrOriginGroup"
                @openInfo="showInfo(messages.originOrOriginGroup.title, messages.originOrOriginGroup.message)"
              >
                <custom-select
                  v-model="selectedOrigin"
                  :options="originOptions"
                  :state="originIdError"
                  placeholder="Select"
                  @input="onChange()"
                />
              </input-field>
            </paper-simple>
          </validation-observer>

          <paper-simple class="pb-1">
            <div class="col-lg-12 pr-0 pl-0 d-flex justify-content-between flex-wrap gap-between">
              <input-field
                class="col pr-0 pl-0"
                label="Allowed HTTP Methods"
                label-position="top"
                info-position="label"
                :info="messages.allowedHttpMethods"
                @openInfo="showInfo(messages.allowedHttpMethods.title, messages.allowedHttpMethods.message)"
              >
                <div class="w-100">
                  <custom-select
                    v-if="behaviors.allowedHttpMethodsOptions"
                    v-model="behaviors.allowedHttpMethods"
                    :options="getOptions(behaviors.allowedHttpMethodsOptions)"
                  />
                </div>
              </input-field>

              <input-field
                class="col pr-0 pl-0"
                label="Cached HTTP Methods"
                label-position="top"
                info-position="label"
                :info="messages.cachedHttpMethods"
                @openInfo="showInfo(messages.cachedHttpMethods.title, messages.cachedHttpMethods.message)"
              >
                <div class="w-100">
                  <custom-select
                    v-if="behaviors.cachedHttpMethodsOptions"
                    v-model="behaviors.cachedHttpMethods"
                    :options="getOptions(behaviors.cachedHttpMethodsOptions)"
                  />
                </div>
              </input-field>
            </div>

          </paper-simple>

          <paper-simple>
            <input-field
              label="Cache Policy"
              label-position="top"
              info-position="label"
              :info="messages.cachePolicy"
              @openInfo="showInfo(messages.cachePolicy.title, messages.cachePolicy.message)"
            >
              <div class="w-100">
                <custom-select
                  v-if="behaviors.cachePolicyOptions"
                  v-model="behaviors.cachePolicyId"
                  :options="getOptions(behaviors.cachePolicyOptions)"
                />
                <div class="d-flex flex-wrap">
                  <b-button
                    variant="bg-white"
                    class="icon-left mt-1"
                    target="_blank"
                    :href="`/${projectId}/cache-policy/${behaviors.cachePolicyId}/info`"
                  >
                    View policy details
                  </b-button>
                  <b-button
                    variant="bg-white"
                    class="mt-1"
                    @click="showCacheForm = true"
                  >
                    <GjIcon
                      class="icon-left"
                      name="Plus"
                    />
                    Create a new policy
                  </b-button>
                </div>
              </div></input-field>
          </paper-simple>

          <paper-simple>
            <input-field
              label="Origin Request Policy"
              label-position="top"
              info-position="label"
              :info="messages.originRequestPolicies"
              @openInfo="showInfo(messages.originRequestPolicies.title, messages.originRequestPolicies.message)"
            >
              <div class="w-100">
                <custom-select
                  v-if="behaviors.originRequestPolicyOptions"
                  v-model="behaviors.originRequestPolicyId"
                  :options="getOptions(behaviors.originRequestPolicyOptions)"
                />
                <div class="d-flex flex-wrap">
                  <b-button
                    variant="bg-white"
                    class="icon-left mt-1"
                    target="_blank"
                    :href="`/${projectId}/request-policy/${behaviors.originRequestPolicyId}/info`"
                  >
                    View policy details
                  </b-button>
                  <!-- <b-button
                    variant="bg-white"
                    class="mt-1"
                    @click="showRequestForm = true"
                  >
                    <GjIcon
                      class="icon-left"
                      name="Plus"
                    />
                    Create a new policy
                  </b-button> -->
                </div>
              </div>
            </input-field>
          </paper-simple>
        </template>

        <template v-slot:footer>
          <template v-if="elementary">
            <b-button
              variant="bg-white"
              @click="$emit('close', distributionId)"
            >
              Cancel
            </b-button>
            <button-loading
              variant="bg-primary"
              class="ml-16"
              :spinning="details ? updatingBehavior : addingBehavior"
              @click="validationBehaviorSettings"
            >
              {{ details ? 'Update' : 'Create' }}
            </button-loading>
          </template>
        </template>

      </form-wrapper>

      <template v-if="loading || !loaded">
        <div class="loading">
          <GjIcon name="Loader" />
        </div>
      </template>

      <template v-if="showCacheForm">
        <cache-form
          @close="showCacheForm = false"
          @onCreate="onCreateCachePolicies()"
        />
      </template>

      <template v-if="showRequestForm">
        <request-form
          @close="showRequestForm = false"
          @onCreate="onCreateRequestPolicies()"
        />
      </template>

      <info
        v-if="openInfo"
        :title="infoTitle"
        :message="infoMessage"
        @close="openInfo = false"
      />
    </div>
  </parent>
</template>
<script>
import CachePoliciesFrom from '@/views/cdn/policies/cache/CachePoliciesForm.vue'
import RequestPoliciesFrom from '@/views/cdn/policies/request/RequestPoliciesForm.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import messages from '../../messages'
import redirectError from '@/services/redirectError'

export default {
  name: 'BehaviorsForm',
  components: {
    'cache-form': CachePoliciesFrom,
    'request-form': RequestPoliciesFrom,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    id: {
      default: null,
      type: Number,
    },
    details: {
      type: Boolean,
      default: false,
    },
    elementary: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      required,
      messages,
      openInfo: false,
      infoTitle: '',
      infoMessage: '',
      selectedOrigin: null,
      originOptions: [],
      origins: [],
      originGroups: [],
      showCacheForm: false,
      showRequestForm: false,
      originIdError: null,
      distributionId: null,
      loaded: false,
    }
  },
  computed: {
    behaviors() {
      return this.$store.state.cdn.behavior
    },
    updatingBehavior() {
      return this.$store.state.cdn.updatingBehavior
    },
    addingBehavior() {
      return this.$store.state.cdn.addingBehavior
    },
    loading() {
      return this.$store.state.cdn.gettingBehavior
    },
    breakpoint() {
      return this.$store.getters['app/currentBreakPoint']
    },
    projectId() {
      return this.$store.state.app.projectId
    },
  },
  created() {
    this.distributionId = this.$route.params.id
    this.$store.dispatch('cdn/getBehavior', {
      distributionId: this.distributionId,
      id: this.id,
    })
      .then(() => this.initialize())
      .catch(err => redirectError(err, this.$router, this.$route.path))
  },
  methods: {
    initialize() {
      if (this.details) {
        if (this.behaviors.isOriginGroup) {
          this.selectedOrigin = `1${this.behaviors.originId}`
        } else {
          this.selectedOrigin = `0${this.behaviors.originId}`
        }
      } else {
        this.behaviors.distributionId = this.distributionId
        this.behaviors.pathPattern = ''
        this.behaviors.cachePolicyId = this.behaviors.cachePolicyOptions[0].id
        this.behaviors.originRequestPolicyId = this.behaviors.originRequestPolicyOptions[0].id
      }

      this.$store.dispatch('cdn/fetchOrigins', this.distributionId).then(() => {
        this.origins = this.$store.state.cdn.origins
        for (let i = 0; i < this.origins.length; i++) {
          const localOrigin = this.origins[i]
          this.originOptions.push({
            value: `0${localOrigin.id}`,
            text: localOrigin.originId,
          })

          if (this.selectedOrigin === null && i === 0) {
            this.selectedOrigin = `0${localOrigin.id}`
          }
        }
        this.loaded = true
      }).catch(error => this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while fetching origins.'))

      this.$store.dispatch('cdn/fetchOriginGroups', this.distributionId).then(() => {
        this.originGroups = this.$store.state.cdn.origingroups
        for (let i = 0; i < this.originGroups.length; i++) {
          const originGroup = this.originGroups[i]
          this.originOptions.push({
            value: `1${originGroup.id}`,
            text: originGroup.originId,
          })

          if (this.selectedOrigin === null && i === 0) {
            this.selectedOrigin = `1${originGroup.id}`
          }
        }
      }).catch(error => this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while fetching origin groups.'))
    },
    onChange() {
      if (this.selectedOrigin !== null) {
        const isOriginGroup = this.selectedOrigin.charAt(0)
        this.behaviors.originId = this.selectedOrigin.slice(1)
        // eslint-disable-next-line eqeqeq
        this.behaviors.isOriginGroup = isOriginGroup == 1
      }
    },
    showInfo(title, info) {
      this.openInfo = true
      this.infoTitle = title
      this.infoMessage = info
    },
    onCreateCachePolicies() {
      this.$store.dispatch('cdn/getBehaviorPolicies', {
        distributionId: 0,
        id: 0,
      })
        .then(() => {
          this.behaviorModel.cachePolicyOptions = this.$store.state.cdn.behaviorCachePolicyOptions
        })
        .catch(error => { this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while fetching policies.') })
    },
    onCreateRequestPolicies() {
      this.$store.dispatch('cdn/getBehaviorPolicies', {
        distributionId: 0,
        id: 0,
      })
        .then(() => {
          this.behaviorModel.originRequestPolicyOptions = this.$store.state.cdn.behaviorOriginRequestPolicyOptions
        })
        .catch(error => { this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while fetching policies.') })
    },
    validationBehaviorSettings() {
      return new Promise((resolve, reject) => {
        this.$refs.behaviorRules.validate().then(success => {
          if (success) {
            this.onChange()
            const localBehavior = {
              id: this.behaviors.id,
              distributionId: this.behaviors.distributionId,
              pathPattern: this.behaviors.pathPattern,
              isOriginGroup: this.behaviors.isOriginGroup,
              originId: this.behaviors.originId,
              viewerProtocolPolicy: this.behaviors.viewerProtocolPolicy,
              allowedHttpMethods: this.behaviors.allowedHttpMethods,
              cachedHttpMethods: this.behaviors.cachedHttpMethods,
              compressObjectsAutomatically: this.behaviors.compressObjectsAutomatically,
              cachePolicyId: this.behaviors.cachePolicyId,
              originRequestPolicyId: this.behaviors.originRequestPolicyId,
              objectCaching: this.behaviors.objectCaching,
              onTheFlyPackaging: this.behaviors.onTheFlyPackaging,
            }
            this.$emit('submit', localBehavior)
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>
<style lang="scss" scoped>

.gap-between{
  gap: 10px;
}
.behaviors-form-wrapper {
  ::v-deep {
    .form-wrapper {
      &__body {
        > div {
          margin: auto;
        }
      }
    }
    .card.paper {
      .card-body {
        padding-bottom: 0;
      }
    }

    .info-assistant {
      margin-left: auto;
    }
  }
  .onfp-checkbox{
    ::v-deep {
      .form-row{
        display: block !important;
      }
      .col{
        .labelMargin{
          display: none !important;
        }
      }
      .info-assistant {
        margin-left: 0 !important;
      }
    }
  }
}
</style>
